module.exports = __webpack_public_path__ + "media/images/glyphicons-195-question-sign-2b0a5fc2.png";